export enum PARENT_COMPANY_FINANCIAL_REPORT_DATE {
Q1 = 'Q1',
Q2 = 'Q2',
Q3 = 'Q3',
Q4 = 'Q4',
FULL_YEAR = 'Full Year',
ANNUAL = 'Annual',
}
